import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { MediaProps, MediaType } from '../media-constant';

import * as React from 'react';
import { RenderElementProps } from 'slate-react';
import { Typography } from '../../../DesignSystemV2/Typography';

export const renderVideoUpload = (opt: MediaProps) => (props: RenderElementProps) => {
  const { element } = props;
  if (element.type === MediaType.VIDEO) {
    if (!element.videoUrl) return null;
    return (
      <div className="attached-file" contentEditable={false}>
        Video đính kèm:{' '}
        <a href={element.videoUrl}>
          <Typography.Text
            color="blue100"
            style={{ textDecoration: 'underline' }}
            variant="regular/14"
          >
            {element.videoUrl}
          </Typography.Text>
        </a>
      </div>
    );
  }
  return null;
};

export const UploadVideoEmailPlugin = (props?: MediaProps): SlatePlugin => {
  return {
    renderElement: renderVideoUpload(props),
    voidTypes: [MediaType.VIDEO],
  };
};
